import React from 'react'

import { type GlobalEventHandler } from '../../core'
import type { AppStore } from '../stores/AppStore'

export interface InsightsMicroWidgetContextTypes {
  children: React.ReactNode
  onEvent: GlobalEventHandler
  onPageview: (page: string) => void
  store: AppStore
}

export const InsightsMicroWidgetDataContext =
  React.createContext<InsightsMicroWidgetContextTypes | null>(null)

export const InsightsMicroWidgetDataProvider: React.FC<InsightsMicroWidgetContextTypes> = ({
  onEvent,
  onPageview,
  store,
  children,
}) => (
  <InsightsMicroWidgetDataContext.Provider value={{ onEvent, onPageview, store, children }}>
    {children}
  </InsightsMicroWidgetDataContext.Provider>
)
